/*
 * Filename: partners.js
 * By: J. Nguyen
 * Date: 2/8/23
 *
 * Description: 
 * This will be used to control the page js functionality for the partners page.
 *
 */


import Accordion from '../modules/accordion';
import ClientCarousel from '../modules/client-carousel';

const defaults = {             
  debugMode: false
}

// DOM NODES
const pageNode = document.getElementById('page-partners');
const accordionPanel = document.getElementById('js-accordion');
const clientCarouselPanel = document.getElementById('js-client-carousel-panel');



init();
 
// initilize the module
function init() {
  debug("inside partners init()");

  Accordion(accordionPanel, {});
  ClientCarousel(clientCarouselPanel, {});

}




// Basic debug function
function debug(msg) { 
  if (defaults.debugMode) {
    console.log(msg);
  }
}

